
    import { Options, Vue } from "vue-class-component";
    import { namespace } from "vuex-class";
    const authStore = namespace("auth");
    import CardRh from "@/components/cards/ManzaCard.vue";
    import MatriculaService from "@/service/v1/sigap/MatriculaService";
    import SiteUtils from "@/assets/ts/aplicacao/site";
    import KDataTable from "@/components/datatable/newdatatable.vue";
    import { PerfilConfig } from "@/core/config/PerfisConfig";
    import { Prop } from "vue-property-decorator";

    @Options({
        name: "VerificacaoFinalMatriculaIndex",
        components: { CardRh, KDataTable },
    })
    export default class VerificacaoFinalMatriculaIndex extends Vue {
        @Prop() readonly matricula!: any;

        @authStore.Getter
        public perfis!: any;

        public processando = false;
        public reloadDatatable = false;
        public config: any = null;
        public service: any = null;
        public matriculaId: any = null;
        public search = "";

        get hasPermissao(): boolean {
            return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE, PerfilConfig.AuxSTE], this.perfis);
        }

        public refreshTable() {
            setTimeout(() => {
                this.reloadDatatable = !this.reloadDatatable;
            }, 300);
        }

        public apertouEnter(e) {
            if (e.key === "Enter" || e.keyCode === 13) {
                this.refreshTable();
            }
        }

        public limparFiltros() {
            this.search = "";
            this.refreshTable();
        }

        created() {
            this.matriculaId = this.$route.params.id;
            this.config = { ajax: {}, columns: [], columnDefs: [], order: [] };
            this.service = new MatriculaService();
            this.config.ajax = {
                url: this.service.getApiUrl() + "/" + this.matriculaId + "/VerificacaoFinal",
                data: (d) => {
                    const dados = {
                        Skip: d.start,
                        Take: d.length,
                        search: this.search || d.search.value,
                    };
                    return dados;
                }
            };
            this.config.columns = [
                { data: "descricao", name: "descricao" , orderable: false},
                { data: "tipo", name: "tipo" , orderable: false},
                { data: "mediaAluno", name: "mediaaluno", orderable: false },
            ];

            this.config.columnDefs = [
                {
                    targets: 1,
                    render: (row) => {
                        return row.nome.replaceAll("_", " ");
                    }
                },
            ];
        }
    }
